import { render, staticRenderFns } from "./publicForm.vue?vue&type=template&id=761ba87d&scoped=true"
import script from "./publicForm.vue?vue&type=script&lang=js"
export * from "./publicForm.vue?vue&type=script&lang=js"
import style0 from "./publicForm.vue?vue&type=style&index=0&id=761ba87d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761ba87d",
  null
  
)

export default component.exports